import { styled } from '@linaria/react';
import { AgentMinerSessionStatus } from '../../../api/agent-miner-client/agent-miner-client.type';
import { blueBase, primaryBase, redBase, skyDark } from '../../../styles/design-tokens';

type StatusDotProps = {
  status: AgentMinerSessionStatus | string;
  size?: number;
};

const STATUS_COLORS: Record<string, string> = {
  [AgentMinerSessionStatus.Completed]: primaryBase,
  [AgentMinerSessionStatus.Active]: blueBase,
  [AgentMinerSessionStatus.Error]: redBase,
  [AgentMinerSessionStatus.Cancelled]: skyDark,
};

export function StatusDot({ status, size = 8 }: StatusDotProps) {
  const color = STATUS_COLORS[status] ?? skyDark;
  const pulse = status === AgentMinerSessionStatus.Active;
  return <Dot color={color} size={size} pulse={pulse} aria-label={String(status).toLowerCase()} />;
}

const Dot = styled.span<{ color: string; size: number; pulse: boolean }>`
  position: relative;
  display: inline-block;
  flex-shrink: 0;
  width: ${(props) => `${props.size}px`};
  height: ${(props) => `${props.size}px`};
  border-radius: 50%;
  background: ${(props) => props.color};
  box-shadow: ${(props) => (props.pulse ? `0 0 0 3px ${props.color}33` : 'none')};

  @keyframes agentMinerPulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.45;
    }
  }

  animation: ${(props) => (props.pulse ? 'agentMinerPulse 1.6s ease-in-out infinite' : 'none')};
`;
